import Dialog from "dialog";
import template from "../html/dialog-config-o2.html";
import css from "../css/dialog-config-o2.css";

class ConfigO2Dialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-o2", ConfigO2Dialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.o2Sensor.id;
    this.textboxDeviceStatus.value = devices.o2Sensor.status;
    this.textboxValue.value = devices.o2Sensor.value;
    this.textboxInternalTemperature.value = devices.o2Sensor.internalTemperature;
    this.textboxInternalBarometricPressure.value = devices.o2Sensor.internalBarometricPressure;
    this.textboxOnBoardTemperature.value = devices.o2Sensor.onBoardTemperature;
    this.textboxOnBoardBarometricPressure.value = devices.o2Sensor.onBoardBarometricPressure;
    this.textboxOnBoardRelativeHumidity.value = devices.o2Sensor.onBoardRelativeHumidity;

  }
  buttonClose_click(event) {
    this.close();
  }
  async buttonCalibrateZero_click(event) {
    try {
      this.buttonCalibrateZero.icon.iconname = "view-refresh";
      await server.rcall("RM_o2sensor_calibratezero");
      this.buttonCalibrateZero.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateZero.icon.iconname = "process-stop";
    }
  }
  async buttonCalibrateSpan_click(event) {
    try {
      this.buttonCalibrateSpan.icon.iconname = "view-refresh";
      await server.rcall("RM_o2sensor_calibratespan", parseInt(this.textboxCalibrateSpan.value));
      this.buttonCalibrateSpan.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateSpan.icon.iconname = "process-stop";
    }
  }
  close() {
    super.close();
  }
}

ConfigO2Dialog.constructor();

export default ConfigO2Dialog;